"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const queuer = require("@tanstack/pacer/queuer");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useQueuer(fn, options = {}, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().queuer,
    ...options
  };
  const [queuer$1] = react.useState(() => new queuer.Queuer(fn, mergedOptions));
  queuer$1.fn = fn;
  queuer$1.setOptions(mergedOptions);
  const state = reactStore.useStore(queuer$1.store, selector);
  return react.useMemo(
    () => ({
      ...queuer$1,
      state
    }),
    // omit `store` in favor of `state`
    [queuer$1, state]
  );
}
exports.useQueuer = useQueuer;
//# sourceMappingURL=useQueuer.cjs.map
